export * from './heroAnimation';
export * from './rulesAnimation';
export * from './experienceAnimation';
export * from './conditionsAnimation';
export * from './aboutProgramAnimation';
export * from './requirementsAnimation';
export * from './startPositionAnimation';
export * from './stagesAnimation';
